<template>
  <div>
    <b-modal v-model="modalActive" width="90%" scroll="keep">
      <div class="card">
        <header class="card-header ">
          <div class="card-header-title is-flex">
            <h6 class="is-size-6 ml-auto mr-auto pl-4 has-text-weight-semibold">{{ title }}</h6>
          </div>
          <b-button class="card-header-icon mt-2 mr-2" aria-label="more options" @click="show(false, false, false)">
            <b-icon icon="close"></b-icon>
          </b-button>
        </header>
        <div class="card-content" :style="isProcessingEditOrAddAllowed(data) ? 'height:600px' : 'height: 300px'">
          <div class="content" v-if="data">

            <div class="m-0 p-0 pr-2 pl-0">
              <div class="is-size-7 has-text-grey-light mt-1">Site Name</div>
              <div class="mt-0 has-text-weight-semibold">{{ data.siteName }}</div>
            </div>

            <div class="m-0 p-0 pr-2 pl-0">
              <div class="is-size-7 has-text-grey-light mt-1">Device Name</div>
              <div class="mt-0 has-text-weight-semibold">{{ data.name }}</div>
            </div>

            <div v-if="infoType && infoType === 'periods'" class="mt-3 mb-6">
              <div class="m-0 p-0 pr-2 pl-0" v-if="data.processingPeriods">
                <div class="is-size-7 has-text-grey-light mt-1">Processing periods</div>
                <div class="is-flex" v-for="(period, index) in this.data.processingPeriods" :key="index">
                  <div v-if="processingPeriodByIndex(index)" class="is-flex">
                    <b-icon icon="calendar" size="is-small" class="mt-1 mr-1"></b-icon>
                    <div>{{ processingPeriodByIndex(index) }}</div>
                    <div class="is-flex is-flex-direction-column ml-4">
                      <div v-for="timeRange in processingTimesByIndex(index)" :key="timeRange">
                        <div class="is-flex">
                          <b-icon icon="clock-outline" size="is-small" class="ml-2 mt-1 mr-1"></b-icon>
                          <div>{{ timeRange }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="is-size-6 has-text-weight-normal has-text-warning">Undefined</div>
                </div>
                <div v-if="isProcessingEditOrAddAllowed(data)">
                  <div class="mt-6">Edit processing periods</div>
                  <processing-input
                      class="mt-3 ml-0"
                      :show-copy-actions="false"
                      :initial-collection-period="data.collectionPeriod"
                      :initial-processing-period="data.processingPeriod"
                      :initial-processing-periods="data.processingPeriods"
                      @processingPeriodsChanged="onProcessingPeriodsChanged(data, $event)">
                  </processing-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer class="card-footer" v-if="isProcessingEditOrAddAllowed(data) && infoType && infoType === 'periods'">
          <b-button class="is-primary is-fullwidth m-2"  :disabled="processingPeriods === null || processingPeriods.length === 0" @click="onSaveClicked" rounded>Update Processing periods
          </b-button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {convertPeriodToDateIsoStrings, getDateRange, parseTimeRanges} from "@/utils/utils";
import ProcessingInput from "@/modules/data-processing-module/components/processing-input/processing-input.vue";
import {isProcessingEditOrAddAllowed} from "@/utils/helper";

export default {
  name: "info-modal",
  components: {ProcessingInput},
  data() {
    return {
      isLoading: false,
      modalActive: false,
      data: null,
      title: null,
      infoType: null,
      processingPeriods:[]
    }
  },
  mounted() {
    this.processingPeriods = []
  },
  methods: {
    isProcessingEditOrAddAllowed,
    show(show, data, title, infoType) {
      this.processingPeriods = []
      this.data = data
      this.title = title
      this.infoType = infoType
      this.modalActive = show
    },
    processingPeriodByIndex(index) {
      if (this.data && this.data.processingPeriods && this.data.processingPeriods.length > 0) {
        if (this.data.processingPeriods[index].dateRange && this.data.processingPeriods[index].dateRange.length > 1) {
          return getDateRange(this.data.processingPeriods[index].dateRange)
        }
      }
      return null
    },
    processingTimesByIndex(index) {
      if (this.data && this.data.processingPeriods && this.data.processingPeriods.length > 0) {
        if (this.data.processingPeriods[index].dateRange && this.data.processingPeriods[index].dateRange.length > 1) {
          return parseTimeRanges(this.data.processingPeriods[index].timeRanges)
        }
      }
      return null
    },
    onProcessingPeriodsChanged(dev, event){
      console.log('On Processing PeriodS Changed: ', dev, event)

      this.processingPeriods = []
      if(event && event.length > 0){
        event.forEach(period => {
          this.processingPeriods.push(convertPeriodToDateIsoStrings(period))
        })
      }
      console.log('New processing periods: ', this.processingPeriods)

    },
    onSaveClicked(){
      console.log('On update processing periods')
      this.$emit('onUpdateProcessingPeriods', {dataDeviceId: this.data._id, processingPeriods: this.processingPeriods})
    }
  }
}
</script>

<style scoped lang="scss">
</style>